import React from 'react';

import { adlessCommand, commandResponse } from '.'
import { NewsletterSignupRequest, NewsletterSignupResponse, NewsletterVerifyRequest, NewsletterVerifyResponse } from 'api/gen/public'

export const newsletter_signup = (req: NewsletterSignupRequest) => adlessCommand<NewsletterSignupResponse>("/v1/public/newsletter/signup", req)
export const newsletter_verify = (req: NewsletterVerifyRequest) => adlessCommand<NewsletterVerifyResponse>("/v1/public/newsletter/verify", req)
